import { type LogtoConfig, UserScope } from '@logto/react';

export const config: LogtoConfig = {
  endpoint: import.meta.env.VITE_APP_LOGTO_ENDPOINT,
  appId: import.meta.env.VITE_APP_LOGTO_CLIENT_ID,
  scopes: [UserScope.Email, UserScope.Organizations, 'urn:logto:scope:organization_roles'],
  resources: ['urn:logto:resource:organizations', import.meta.env.VITE_LOGTO_AUDIENCE],
};
